<template>
  <div class=" tailor">
    <nav class="navbar navbar-dark bg-orange-custom sticky-top" >
      <a class="navbar-brand" href="#">Add New Hazard <i class="fa fa-comment"></i></a>
      <a href="#" class="text-light" v-on:click="resetForm()" v-b-tooltip.hover title="Close">
        <i class="fas fa-2x fa-times-circle"></i>
      </a>
    </nav>
    <br>
    <div class="row container">
      <div class="col">
        Click the "Select Location" button and select a location in the 3D View
        <button v-on:click="addNewHazardLayer()" class="btn btn-primary mr-2" title="Click to start adding hazards" :disabled="disableSelectLocation" >
        Select Location
        </button>
        <button v-on:click="doneAddingHazardLayers()" class="btn btn-primary" title="Click to finish adding hazards" :disabled="disableDoneButton">
        Done
        </button>
      </div>
    </div>
    <hr>
    <br>
    <template v-if="isLocationSelected">
      <div class="row container">
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Hazard No.</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="hazardNo" type="text" disabled>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Organization</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedOrganization" required>
                <option value="" disabled selected></option>
                <option v-for="organization in organizationOptions"  :key="organization.id" :value="organization.code">{{organization.name}}</option>
              </select>
            </div>
          </div> -->
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Discipline</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedDiscipline" required>
                <option value="" disabled selected></option>
                <option v-for="discipline in disciplineOptions"  :key="discipline.id" :value="discipline.code">{{discipline.name}}</option>
              </select>
            </div>
          </div> -->
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Hazard Type</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedHazardType" required>
                <option value="" disabled selected></option>
                <option value="hazard1">Hazard1</option>
                <option value="hazard2">Hazard2</option>
                <option value="hazard3">Hazard3</option>
                <option value="hazard4">Hazard4</option>
                <option value="hazard5">Hazard5</option>
              </select>
            </div>
          </div> -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Model View</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedModelView" required>
                <option value="" disabled selected></option>
                <option v-for="(item, index) in modelViewList" :key="index" :value="item.code">{{item.label}}</option>
                <!-- <option value="straight_platforms">01. Straight Platforms</option>
                <option value="curved_platforms">02. Curved Platforms</option>
                <option value="buffer_stops">03. Buffer Stops</option>
                <option value="train_platform_collision">04. Train-Platform Collision</option>
                <option value="southern_services_collision">05. Collision with Southern Services (Metro) Building</option>
                <option value="train_object_person_collision">06. Train Object/Person Collision</option>
                <option value="ohw_power_electrocution">07. OHW, Power and Electrocution</option>
                <option value="fire_ventilation">08. Fire and Ventilation</option>
                <option value="spills_drainage_flooding">09. Spills, Drainage and Flooding</option>
                <option value="om_tunnels_evacuations">10. O&M, Tunnels, Evacutions</option> -->
              </select>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Addressed to</label>
            <div class="col-sm-8">
              <Multiselect
                v-model="addressedTo"
                :options="emails"
                label="label"
                track-by="value"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addAddressedToTag"
                >
              </Multiselect> -->
              <!-- <Multiselect
                v-model="addressedTo"
                :options="userFilteredList"
                group-values="users"
                group-label="organization"
                label="userEmail"
                track-by="userEmail"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addAddressedToTag"
                >
              </Multiselect> -->
            <!-- </div>
          </div> -->

        </div>
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Created by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="hazardCreatedBy" type="text" disabled>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Request Created</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="requestCreated" type="date" disabled>
            </div>
          </div>

          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">CC</label>
            <div class="col-sm-8">
              <Multiselect
                v-model="ccEmail"
                :options="emails"
                label="label"
                track-by="value"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addCCEmailTag"
                >
              </Multiselect> -->
              <!-- <Multiselect
                v-model="ccEmail"
                :options="userFilteredList"
                group-values="users"
                group-label="organization"
                label="userEmail"
                track-by="userEmail"
                placeholder="Email"
                hide-selected
                multiple
                :taggable="true"
                @tag="addCCEmailTag"
                >
              </Multiselect> -->
            <!-- </div>
          </div> -->
        </div>
      </div>
      <hr style="margin-top: 0;">
      <div class="row container">
        <div class="col-6">
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Type</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedType" required>
                <option value="" disabled selected></option>
                <option value="type1">Type 1</option>
                <option value="type2">Type 2</option>
                <option value="type3">Type 3</option>
                <option value="type4">Type 4</option>
                <option value="type5">Type 5</option>
                <!-- <option value="constructability">Constructability</option>
                <option value="health_safety">Health & Safety</option>
                <option value="3d_model">3D Model</option>
                <option value="coordination">Coordination</option>
                <option value="design">Design</option> -->
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Status</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="approvalStatus" type="text" disabled>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Work Package</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedWorkPackage" required>
                <option value="" disabled selected></option>
                <option v-for="workPackage in workPackageOptions"  :key="workPackage.id" :value="workPackage.code">{{workPackage.name}}</option>
              </select>
            </div>
          </div> -->


          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Response Required by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="responseRequiredBy" type="date" required>
            </div>
          </div> -->
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Update by</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="updateBy" type="text" required>
            </div>
          </div> -->
        </div>
        <div class="col-6">
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Type</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedType" required>
                <option value="" disabled selected></option>
                <option value="constructability">Constructability</option>
                <option value="health_safety">Health & Safety</option>
                <option value="3d_model">3D Model</option>
                <option value="coordination">Coordination</option>
                <option value="design">Design</option>
              </select>
            </div>
          </div> -->

          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Priority</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedPriority" required>
                <option value="" disabled selected></option>
                <option value="critical">Critical</option>
                <option value="major">Major</option>
                <option value="minor">Minor</option>
              </select>
            </div>
          </div> -->
          <div class="form-group row">
            <label class="col-sm-4 col-form-label">Risk Classification</label>
            <div class="col-sm-8">
              <select class="form-control" v-model="selectedSeverity" required>
                <option value="" disabled selected></option>
                <option value="a">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
                <option value="d">D</option>
                <!-- <option value="critical">Critical</option>
                <option value="major">Major</option>
                <option value="minor">Minor</option> -->
              </select>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-sm-4 col-form-label">Status</label>
            <div class="col-sm-8">
              <input class="form-control" v-model="approvalStatus" type="text" disabled>
            </div>
          </div> -->
        </div>
      </div>
      <div class="row container">
        <div class="col-12">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Hazard Comments</label>
            <div class="col-sm-10">
              <textarea style="resize:none;" rows="3" class="form-control" v-model="textRequest" required></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">File Upload</label>
            <div class="col-sm-6">
              <b-form-file id="fileUpload"></b-form-file>
            </div>
          </div>
          <div class="text-right">
            <button v-on:click="submitNewHazardLayer()" class="btn btn-outline-primary mr-2" title="Click to submit hazard">
              Submit
            </button>
            <button v-on:click="resetForm()"
              class="btn btn-outline-danger"
               title="Click to cancel">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl, appBaseUrl} from "../../config.js"
import axios from "axios"
import Multiselect from "vue-multiselect"

export default {
  name: 'NewHazard',
  components: {
    Multiselect
  },
  data () {
    return {
      userName: this.$store.state.mapModule.userName,
      HazardNo: "",
      textHazard: "",
      addressedTo: [],
      ccEmail: [],
      hazardCreatedBy: this.$store.state.mapModule.user.fullName,
      requestCreated: "",
      responseRequiredBy: "",
      updateBy: "",
      selectedHazardType: "",
      selectedModelView: "",
      selectedType: "",
      // selectedStatus: "pending",
      textRequest: "",
      selectedDiscipline: "",
      selectedPriority: "",
      selectedSeverity: "",
      selectedOrganization: "",
      selectedWorkPackage: "",
      dueDate: "",
      approvalStatus: "Pending",
      isLocationSelected: false,
      selectedEmail: [],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      emails: [
        {
          value: "leonardo.quines@arcadis.com",
          label: "leonardo.quines@arcadis.com"
        },
        {
          value: "sheena.verdad@arcadis.com",
          label: "sheena.verdad@arcadis.com"
        },
        {
          value: "Rittick.Borah@arcadis.com",
          label: "Rittick.Borah@arcadis.com"
        },
        {
          value: "Nalin.Senevirathne@arcadis.com",
          label: "Nalin.Senevirathne@arcadis.com"
        }
      ],
      errorMsgDictionary: {
        noRequestDetailsFound: "Hazard Comments field was left blank",
        noDisciplineFound: "Discipline field was left blank",
        noPriorityFound: "Priority field was left blank",
        noSeverityFound: "Risk Classification field was left blank",
        noResponseRequiredByFound: "Response Required By field was left blank",
        noAddressedToFound: "Addressed To field was left blank",
        noHazardTypeFound: "Hazard Type field was left blank",
        noModelViewFound: "Model View field was left blank",
        noTypeFound: "Type field was left blank",
        noWorkPackageFound: "Work Package field was left blank"
      },
      newHazardGeometry: {
        longitude: null,
        latitude: null,
        z: null
      },
      disciplineOptions: {},
      organizationOptions: {},
      workPackageOptions: {},
      points: [],
      hazardPoints: [],
      onceClick: null,
      disableSelectLocation: false,
      disableDoneButton: true,
      modelViewList: [
        {
          label: "01. O&M, Tunnels, Evacutions",
          code: "om_tunnels_evacuations",
        },
        {
          label: "02. Train-train collision / Scissors",
          code: "train_collision_scissors",
        },
        {
          label: "3A. SYAB Angled",
          code: "syab_angled",
        },
        {
          label: "3B. SYAB Ground-Level",
          code: "syab_ground_level",
        },
        {
          label: "04. OSD",
          code: "osd",
        },
        {
          label: "05. Collision with southern services building",
          code: "southern_services_collision",
        },
        {
          label: "6A. Straight Platform Entry",
          code: "straight_platform_entry",
        },
        {
          label: "6B. Straight Platform Midpoint",
          code: "straight_platform_midpoint",
        },
        {
          label: "6C. Straight Platform End",
          code: "straight_platform_end",
        },
        {
          label: "7A. Curved Platform Entry",
          code: "curved_platform_entry",
        },
        {
          label: "7B. Curved Platform Midpoint",
          code: "curved_platform_midpoint",
        },
        {
          label: "7C. Curved Platform End",
          code: "curved_platform_end",
        },
      ]
      // modelViewList: [
      //   {
      //     label: "01. Straight Platforms",
      //     code: "straight_platforms",
      //   },
      //   {
      //     label: "02. Curved Platforms",
      //     code: "curved_platforms",
      //   },
      //   {
      //     label: "03. Buffer Stops",
      //     code: "buffer_stops",
      //   },
      //   {
      //     label: "04. Train-Platform Collision",
      //     code: "train_platform_collision",
      //   },
      //   {
      //     label: "05. Collision with Southern Services (Metro) Building",
      //     code: "southern_services_collision",
      //   },
      //   {
      //     label: "06. Train Object/Person Collision",
      //     code: "train_object_person_collision",
      //   },
      //   {
      //     label: "07. OHW, Power and Electrocution",
      //     code: "ohw_power_electrocution",
      //   },
      //   {
      //     label: "08. Fire and Ventilation",
      //     code: "fire_ventilation",
      //   },
      //   {
      //     label: "09. Spills, Drainage and Flooding",
      //     code: "spills_drainage_flooding",
      //   },
      //   {
      //     label: "10. O&M, Tunnels, Evacutions",
      //     code: "om_tunnels_evacuations",
      //   },
      // ]
      // userList: []
    }
  },
  computed: {
    hazardLayerId: {
      get() {
        return this.$store.state.mapModule.staticHazardLayerId
      }
    },
    isAddNewHazard: {
      get() {
        return this.$store.state.mapModule.isAddNewHazard
      }
    },
    hazardFeatureList: {
      get() {
        return this.$store.state.mapModule.initialHazards
      }
    },
    userList: {
      get() {
        return this.$store.state.mapModule.userList
      }
    },
    userFilteredList: {
      get() {
        var finalList = this.userList
        var newList = []
        console.log(this.addressedTo);
        if (this.selectedDiscipline != "") {
          // finalList = this.userList.users.filter(obj=>obj.disciplineCode == this.selectedDiscipline)
          // finalList = this.userList.filter( userListItem =>
          //     userListItem.user.filter( obj =>
          //         obj.disciplineCode == this.selectedDiscipline
          //     )
          // )

          // finalList = this.userList.filter(function(userListItem) {
          // 	return userListItem.user.filter(function(obj) {
          //   	return obj.disciplineCode == this.selectedDiscipline;
          //   });
          // });

          this.userList.forEach((userListItem) => {
            let filteredUser = {
                organization:userListItem.organization,
                users: []
            }

            userListItem.users.forEach((item) => {
              if(item.disciplineCode == this.selectedDiscipline){
                let userItem = {
                  userEmail:item.userEmail,
                  disciplineCode:item.disciplineCode
                }
                filteredUser.users.push(userItem)

              }

            });

            if(this.selectedDiscipline != "gis" && userListItem.organization == "Arcadis"){
              let usertest1 = {
                userEmail: 'leonardo.quines@arcadis.com',
                disciplineCode:this.selectedDiscipline
              }
              let usertest2 = {
                userEmail: 'sheena.verdad@arcadis.com',
                disciplineCode:this.selectedDiscipline
              }
              filteredUser.users.push(usertest1)
              filteredUser.users.push(usertest2)
            }
            newList.push(filteredUser);
          });
          finalList = newList
          console.log(finalList);
        }

        return finalList
      }
    },
    currentUser: {
      get() {
        return this.$store.state.mapModule.user
      }
    },
  },
  methods: {
    addAddressedToTag: function (newTag) {
      console.log(newTag);
      const current = this
      const tag = {
        // userEmail: newTag
        label: newTag,
        value: newTag
      }
      if (current.reg.test(newTag)) {
        current.addressedTo.push(tag)
      }
      else {
        current.$notify({
          group: 'errors',
          title: "Error Adding Email",
          type: 'error',
          text: "Email entered is invalid.",
          width: 500,
          duration: 2000
        })
      }
    },
    addCCEmailTag: function (newTag) {
      console.log(newTag);
      const current = this
      const tag = {
        // userEmail: newTag
        label: newTag,
        value: newTag
      }
      if (current.reg.test(newTag)) {
        current.ccEmail.push(tag)
      }
      else {
        current.$notify({
          group: 'errors',
          title: "Error Adding Email",
          type: 'error',
          text: "Email entered is invalid.",
          width: 500,
          duration: 2000
        })
      }
    },
    addNewHazardLayer: function() {
      const scene = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      const current = this
      current.disableDoneButton = false
      sceneView.graphics.removeAll()
      current.disableSelectLocation = true

      loadModules([
        "dojo/on",
        "esri/Graphic"],{ css: true })
      .then(([
        on,
        Graphic]) => {
        var appMap = document.getElementById("map");
        appMap.style.cursor = "crosshair";
        // var onceClick = on.once(sceneView, "click", (evt) => {

        current.onceClick = on(sceneView, "click", (evt) => {
          // if (appMap.style.cursor === "auto") {
          //   // onceClick.remove();
          //   console.log("event listener removed");
          //   return;
          // }

          sceneView.hitTest(evt).then((hitTestResult) => {
            console.log(hitTestResult);
            // var points = []
            if (hitTestResult.results.length) {
              // var point = hitTestResult.results[0].mapPoint.clone()
              var points = [hitTestResult.results[0]]
              // points.push(hitTestResult.results[0])
            } else {
              // var point = hitTestResult.ground.mapPoint.clone()
              var points = [hitTestResult.ground]
              // points.push(hitTestResult.ground)
            }
            console.log(points);
            points.forEach((pointItem, index) => {
              console.log(pointItem);
              var point = pointItem.mapPoint.clone()
              var newHazardEntry = new Graphic({
                geometry: point,
                attributes: {},
                symbol: {
                  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                  url: "InitialMarker.png",
                  width: 20
                  // type: "point-3d",
                  // symbolLayers: [{
                  //   type: "object",
                  //   anchor: "origin",
                  //   width: 5,
                  //   material: {
                  //     color: [0, 132, 168, 1]
                  //   }
                  // }]
                }
              });
              sceneView.graphics.add(newHazardEntry);
              console.log(newHazardEntry);
              var hazardGeometry = {
                longitude: point.longitude,
                latitude: point.latitude,
                elevation: point.z
              }
              // current.newHazardGeometry.longitude = point.longitude
              // current.newHazardGeometry.latitude = point.latitude
              // current.newHazardGeometry.z = point.z
              current.hazardPoints.push(hazardGeometry)

            });


            // var newHazardEntry = new Graphic({
            //   geometry: point,
            //   attributes: {},
            //   symbol: {
            //     type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
            //     url: "InitialMarker.png",
            //     width: 20
            //     // type: "point-3d",
            //     // symbolLayers: [{
            //     //   type: "object",
            //     //   anchor: "origin",
            //     //   width: 5,
            //     //   material: {
            //     //     color: [0, 132, 168, 1]
            //     //   }
            //     // }]
            //   }
            // });
            // sceneView.graphics.add(newHazardEntry);
            // current.newHazardGeometry.longitude = point.longitude
            // current.newHazardGeometry.latitude = point.latitude
            // current.newHazardGeometry.z = point.z
            // current.isLocationSelected = true
            // appMap.style.cursor = "auto";
          })
        })
      })
    },
    doneAddingHazardLayers: function() {
      const current = this
      var appMap = document.getElementById("map");
      appMap.style.cursor = "auto";
      current.onceClick.remove();
      current.disableSelectLocation = true
      current.disableDoneButton = true

      console.log(current.hazardPoints);
      current.isLocationSelected = true
    },
    saveValidation: function() {
      const current = this
      var errors = []
      // if (current.selectedDiscipline == "") {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Discipline"
      //   errorMessage.errorBody = current.errorMsgDictionary.noDisciplineFound
      //   errors.push(errorMessage)
      // }
      // if (current.addressedTo.length == 0) {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Addressed To"
      //   errorMessage.errorBody = current.errorMsgDictionary.noAddressedToFound
      //   errors.push(errorMessage)
      // }
      // if (current.selectedWorkPackage.length == 0) {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Work Package"
      //   errorMessage.errorBody = current.errorMsgDictionary.noWorkPackageFound
      //   errors.push(errorMessage)
      // }
      // if (current.responseRequiredBy == "") {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Response Required By"
      //   errorMessage.errorBody = current.errorMsgDictionary.noResponseRequiredByFound
      //   errors.push(errorMessage)
      // }
      // if (current.selectedHazardType == "") {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Hazard Type"
      //   errorMessage.errorBody = current.errorMsgDictionary.noHazardTypeFound
      //   errors.push(errorMessage)
      // }
      if (current.selectedModelView == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Model View"
        errorMessage.errorBody = current.errorMsgDictionary.noModelViewFound
        errors.push(errorMessage)
      }
      if (current.selectedType == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Type"
        errorMessage.errorBody = current.errorMsgDictionary.noTypeFound
        errors.push(errorMessage)
      }
      // if (current.selectedPriority == "") {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Priority"
      //   errorMessage.errorBody = current.errorMsgDictionary.noPriorityFound
      //   errors.push(errorMessage)
      // }
      if (current.selectedSeverity == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Risk Classification"
        errorMessage.errorBody = current.errorMsgDictionary.noSeverityFound
        errors.push(errorMessage)
      }
      if (current.requestDetails == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Hazard Comments"
        errorMessage.errorBody = current.errorMsgDictionary.noRequestDetailsFound
        errors.push(errorMessage)
      }
      return errors
    },
    submitNewHazardLayer: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      var errors = current.saveValidation();
      if (errors.length > 0) {
        errors.forEach(item=>{
          current.$notify({
            group: 'errors',
            title: item.errorTitle,
            type: 'error',
            text: item.errorBody,
            width: 500,
            duration: -1
          })
        })
      }
      else {
        var dateToday = current.getDateToday()
        var fileUploadDom = document.getElementById("fileUpload");
        // var hazardSceneLayer = sceneView.map.allLayers.filter(function(item) {
        //   return item.id === current.hazardLayerId;
        // }).items[0];
        var hazardSceneLayer = sceneView.map.findLayerById(current.hazardLayerId)
        var recipients = []
        current.selectedEmail.forEach(item => {
          recipients.push(item.value)
        })
        var addressedToEmail = []
        current.addressedTo.forEach(item => {
            addressedToEmail.push(item.value)
            // addressedToEmail.push(item.userEmail)
        })
        var ccEmailAddress = []
        current.ccEmail.forEach(item => {
          ccEmailAddress.push(item.value)
          // ccEmailAddress.push(item.userEmail)
        })
        ccEmailAddress.push(current.currentUser.email)

        var data = {
          disciplineCode: current.selectedDiscipline,
          priorityCode: current.selectedPriority,
          severityCode: current.selectedSeverity,
          organizationCode: current.selectedOrganization,
          workPackageCode: current.selectedWorkPackage,
          approvalStateCode: current.approvalStatus.toLowerCase(),
          // longitude: current.newHazardGeometry.longitude,
          // latitude: current.newHazardGeometry.latitude,
          // elevation: current.newHazardGeometry.z,
          hazardPoints: current.hazardPoints,
          dueDate: current.dueDate,
          hazardDetails: current.textHazard,
          addressedTo: addressedToEmail,
          ccEmail: ccEmailAddress,
          hazardCreatedBy: current.$store.state.mapModule.user.email,
          requestCreated: current.requestCreated,
          responseRequiredBy: current.responseRequiredBy,
          updateBy: current.updateBy,
          // hazardTypeCode: current.selectedHazardType,
          hazardTypeCode: current.selectedModelView,
          typeCode: current.selectedType,
          requestDetails: current.textRequest,
          recipients: recipients
        }
        var newHazardURL = baseApiUrl + "saveInitialHazard"
        var config  = {
          responseType: 'json'
        }
        axios.post(newHazardURL, data, config).then(response=>{
          // console.log(response);
          // query new Hazard list
          sceneView.map.remove(hazardSceneLayer);
          sceneView.map.allLayers.refresh()
          if(response.data.status == "success"){
            current.$store.dispatch("mapModule/fetchHazardLayer").then(currentHazardLayer=>{
              console.log("just fetched the new hazard Layer");
              sceneView.map.add(currentHazardLayer);
              // sceneView.map.allLayers.remove(hazardSceneLayer);
              console.log(sceneView.map.allLayers);
              // sceneView.graphics.removeAll()
              // sceneView.map.allLayers.add(currentHazardLayer);
              // console.log("before Refresh");
              // sceneView.map.allLayers.refresh()
              // console.log("after Refresh");

              console.log(sceneView.map.allLayers);

              console.log(currentHazardLayer);
              var latestHazard = currentHazardLayer.graphics.items[currentHazardLayer.graphics.items.length-1]
              // response.graphics.items.forEach(hazard=>{
              var featureObject = {}
              featureObject["objectId"] = latestHazard.attributes.id
              // featureObject["globalId"] = latestHazard.attributes.globalid
              featureObject["discipline"] = latestHazard.attributes.discipline
              featureObject["priority"] = latestHazard.attributes.priority
              featureObject["severity"] = latestHazard.attributes.severity
              featureObject["createdBy"] = latestHazard.attributes.hazardCreatedBy
              featureObject["userName"] = latestHazard.attributes.userName
              featureObject["addressedTo"] = latestHazard.attributes.addressedTo
              featureObject["hazardType"] = latestHazard.attributes.hazardType
              featureObject["type"] = latestHazard.attributes.type
              featureObject["requestDetails"] = latestHazard.attributes.requestDetails
              // featureObject["hazard"] = latestHazard.attributes.details
              featureObject["approvalStatus"] = latestHazard.attributes.approvalState
              featureObject["date"] = latestHazard.attributes.date
              featureObject["requestCreated"] = latestHazard.attributes.requestCreated
              featureObject["responseRequiredBy"] = latestHazard.attributes.responseRequiredBy
              featureObject["updateBy"] = latestHazard.attributes.updateBy
              // featureObject["dueDate"] = latestHazard.attributes.dueDate

              // current.hazardFeatureList.push(featureObject)
              // current.hazardIds.push(item.attributes.id)
              // current.$store.commit("mapModule/insertInitialHazards", featureObject)
              // var fileUploadDom = document.getElementById("fileUpload");
              current.uploadAttachment(latestHazard.attributes.id).then(fileDetail=>{
                console.log("just finished uploading the attachent");
                if (fileDetail.hasFile) {
                  featureObject["fileName"] = fileDetail.fileName
                  featureObject["fileId"] = fileDetail.fileId
                }
                // current.sendEmail(featureObject)
                current.$store.commit("mapModule/insertInitialHazards", featureObject)
                console.log(fileDetail);
                current.resetForm()
              })
            })
          }
          else if(response.data.status == "failed"){
            current.$notify({
              group: 'errors',
              title: "Failed to create hazard",
              type: 'error',
              text: response.data.message,
              width: 500,
              duration: -1
            })
          }
        })
      }
    },
    resetForm: function() {
      const current = this
      var view =  document.getElementById("map").__vue__.view
      current.textHazard = ""
      current.selectedDiscipline = ""
      current.selectedPriority = ""
      current.dueDate = ""
      current.approvalStatus= "Pending"
      view.graphics.removeAll()
      document.getElementById("addHazardButton").click();
      current.newHazardGeometry = {
        longitude: null,
        latitude: null,
        z: null
      }
      current.$store.commit("mapModule/setIfAddNewHazardClicked", false)
      var map = document.getElementById("mapContainer")
      if (!current.isAddNewHazard) {
        map.classList.remove("col-6")
        map.classList.add("col-9")
      }
    },
    sendEmail: function(data) {
      const current = this
      var url = baseApiUrl + "sendEmail"

      var addressedToEmail = []
      current.addressedTo.forEach(item => {
          // addressedToEmail.push(item.userEmail)
          addressedToEmail.push(item.value)
      })


      var ccEmailAddress = []
      current.ccEmail.forEach(item => {
        // ccEmailAddress.push(item.userEmail)
        ccEmailAddress.push(item.value)
      })
      ccEmailAddress.push(current.currentUser.email)

      var data = {
        addressedTo: addressedToEmail,
        ccEmail: ccEmailAddress,
        hazardId: data.objectId,
        name: data.createdBy,
        hazardDetails: data.requestDetails,
        discipline: data.discipline,
        priority: data.priority,
        severity: data.severity,
        type: data.type,
        hazardType: data.hazardType,
        responseRequiredBy: data.responseRequiredBy,
        date: data.requestCreated,
        approvalstatus: data.approvalStatus,
        appBaseUrl: appBaseUrl
      }
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log(result.data);
      }).catch((error)=> {
        console.log(error);
      })
    },
    getDateToday: function() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time = hours + ":" + minutes + ":" + seconds + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    uploadAttachment: function(hazardId) {
      return new Promise(function(resolve, reject) {
        var attachmentsSuccessfulCount = 0
        var fileUploadDom = document.getElementById("fileUpload");
        console.log(fileUploadDom);
        if (fileUploadDom.files.length === 1) {
          var fileURL = baseApiUrl + "addHazardAttachment"
          fileUploadDom.files.forEach(item=>{

            var fileData = new FormData();
            fileData.append("fileinput"       , item);
            fileData.append("hazardId"       , hazardId);
            fileData.append("filename"        , item.name);
            fileData.append("filetype"        , item.type);
            var fileConfig = {
              headers: {
                'content-type': 'application/octet-stream'
              },
              responseType: 'json'
            }
            axios.post(fileURL, fileData, fileConfig).then(fileResult=>{
              // result.data.commentAttachments.push(fileResult.data)
              fileResult.data.hasFile = true
              resolve(fileResult.data)
              // attachmentsSuccessfulCount+=1
              // if (attachmentsSuccessfulCount==current.commentAttachments.length) {
              // }
            })
            .catch(error=>{
              console.log(error);
            })
          })
        }
        else {
          resolve(
            {
              hasFile:false
            }
          )
        }

      });
    },
    getDisciplines: function() {
      const current = this
      current.disciplineOptions = {}
      let url = baseApiUrl + "fetchDisciplines"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.disciplineOptions = result.data
      })
    },
    getOrganizations: function() {
      const current = this
      current.organizationOptions = {}
      let url = baseApiUrl + "fetchOrganizations"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.organizationOptions = result.data
      })
    },
    getWorkPackages: function() {
      const current = this
      current.workPackageOptions = {}
      let url = baseApiUrl + "fetchWorkPackages"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result);
        current.workPackageOptions = result.data
      })
    },
    getUsers: function() {
      const current = this
      // current.userList = {}
      let url = baseApiUrl + "fetchUsers"
      let data = {}
      let config = {
        responseType: 'json'
      }
      axios.post(url, data, config)
      .then((result) => {
        console.log(result.data);
        // current.userList = result.data
        current.$store.commit("mapModule/insertUserList", result.data)
        // current.emails
      })
    }
  },
  mounted() {
    const current = this
    current.requestCreated = new Date().toISOString().substring(0,10);

    current.hazardNo = current.hazardFeatureList.length == 0 ? "1":current.hazardFeatureList[current.hazardFeatureList.length - 1].objectId + 1
    current.getDisciplines()
    current.getOrganizations()
    current.getWorkPackages()
    current.getUsers()
    console.log(current.disciplineOptions);
    console.log(current.userList);
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .tailor {
    height: 912px;
    max-height: 99%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .multiselect__tag {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon:after {
    color: white !important;
  }
  .multiselect__option--highlight {
    background: gray !important;
    outline: none;
    color: white;
  }
  .multiselect__option--highlight:after {
    background: gray !important;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
  }
</style>
